import { OptionType } from 'components/UI/SelectField';
import { FeatureList, Range } from 'models';
import { DefaultTheme } from 'styled-components';

export function getColor(theme: DefaultTheme, status?: string): string {
  let color: string;
  switch (status) {
    case 'error':
      color = theme.colors.error;
      break;
    case 'in_sync':
    case 'connected':
    case 'finished':
      color = theme.colors.success;
      break;
    case 'registered':
    case 'disconnected':
      color = theme.colors.info;
      break;
    case 'pending':
    case 'running':
      color = theme.colors.warning;
      break;
    case 'unknown':
    default:
      color = theme.colors.grey3;
  }

  return color;
}

const HAPP_DEVICE = 'happ-device';
const MOWER_DEVICE = 'mower-device';
export function getFeature(features: FeatureList) {
  if (!features) {
    return null;
  }
  if (features[HAPP_DEVICE]) {
    return HAPP_DEVICE;
  }
  if (features[MOWER_DEVICE]) {
    return MOWER_DEVICE;
  }
  return null;
}

export function getFeatureOptionTypes(
  features: FeatureList | undefined
): OptionType[] {
  const specificationsEntry = Object.entries(features || {}).map(
    ([key, value]) => ({ key, value })
  );
  const featureOptions: OptionType[] = specificationsEntry.map(
    (specification) => ({
      key: specification.key,
      label: specification.key,
      value: specification.key,
      spec: specification.value, // since specification value can be incorrect and same as some other features need a spec attribute
    })
  );
  return featureOptions;
}

export function validateType(value: any, type: string, range?: Range): boolean {
  if (type === 'string') {
    return typeof value === 'string';
  }
  if (type === 'boolean') {
    return value === 'true' || value === 'false';
  }
  if (type === 'integer' && range?.type === 'enum') {
    const validEnum = range?.enums?.find(
      (enumValue: any) => `"${enumValue.key}"` === value
    );
    return validEnum !== undefined;
  }
  if (
    (type === 'integer' || type === 'float') &&
    range?.type === 'fixedRange'
  ) {
    return (
      !isNaN(value) &&
      Number(value) >= range.min! &&
      Number(value) <= range.max!
    );
  }
  if (type === 'integer' || type === 'float') {
    return !isNaN(value);
  }
  return true;
}
